import { useQuery } from '@tanstack/react-query';
import { listEligibleCounselors } from '../api/leads';

/** Central Lead Distribution: the only eligible assignment target for a
 * lead is an active Counselor (enforced server-side too — see
 * leads.service.ts's ensureEligibleAssignmentTarget — this is frontend
 * convenience, not the security boundary). Shared by every assign/transfer
 * dialog so the "Counselor-only" list is defined in exactly one place.
 *
 * Backed by GET /leads/eligible-counselors (leads:assign) rather than
 * GET /users + GET /roles — a role like Lead Manager can assign leads
 * without holding users:view/roles:view at all, so routing this dropdown
 * through the Users/Roles modules would leave it unusable for them. */
export const useCounselorOptions = (enabled: boolean) => {
  const query = useQuery({ queryKey: ['leads', 'eligible-counselors'], queryFn: listEligibleCounselors, enabled });

  return {
    counselors: query.data ?? [],
    isLoading: query.isLoading,
  };
};
